export function initScrollToTop() {
  const scrollBtn = document.querySelector('.po-scroll-btn');
  if (!scrollBtn) return;

  window.addEventListener('scroll', () => {
    scrollBtn.classList.toggle('po-scroll-btn_scrolled', window.scrollY > 100);
  });

  scrollBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
